//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { modifyBiddingStatus } from '../../api';
export default {
  name: 'BiddingStatusDialog',
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        item_id: null,
        status: '',
        remarks: ''
      },
      rules: {
        status: [{
          required: true,
          message: '请选择任务状态',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    open: function open(itemId) {
      var _this = this;
      this.form.item_id = itemId;
      this.form.status = '';
      this.form.remarks = '';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.form.clearValidate();
      });
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          var obj = {
            item_id: _this2.form.item_id,
            status: _this2.form.status,
            remarks: _this2.form.remarks
          };
          modifyBiddingStatus(obj).then(function (res) {
            _this2.$message.success('修改成功');
            _this2.dialogVisible = false;
            _this2.$emit('success');
          });
        }
      });
    }
  }
};